import { PersonaFisicaBaseDTO } from './persona-fisica-base-dto';
import { PersonaGiuridicaBaseDTO } from './persona-giuridica-base-dto';

export class MieDelegheDTO {
	personeFisiche: Array<PersonaFisicaBaseDTO>;
	personeGiuridiche: Array<PersonaGiuridicaBaseDTO>;
}